declare global {
  interface Array<T> {
    remove(item: T): void;
    groupBy<K>(selector: (x: T) => K): Map<K, T[]>;
    sum(selector: (x: T) => number): number;
    distinct(): T[];
    distinctBy<TKey>(selector: (x: T) => TKey): T[];
  }

  interface Map<K, V> {
    toArray(): { key: K; value: V }[];
  }
}

Array.prototype['remove'] = function <T>(this: T[], item: T) {
  const index = this.indexOf(item);
  if (index !== -1) {
    this.splice(index, 1);
  }
};

Array.prototype['groupBy'] = function <T, TKey>(this: T[], selector: (x: T) => TKey): Map<TKey, T[]> {
  return this.reduce((current, x) => {
    const key = selector(x);
    let mapArray = current.get(key);
    if (!mapArray) {
      current.set(key, mapArray = []);
    }
    mapArray.push(x);
    return current;
  }, new Map<TKey, T[]>());
};

Array.prototype.sum = function <T>(this: T[], selector: (x: T) => number): number {
  return this.reduce((current, x) => current + selector(x), 0);
};

Array.prototype.distinct = function <T>(this: T[]): T[] {
  return [...new Set(this)];
}

Array.prototype.distinctBy = function <T, TKey>(this: T[], selector: (x: T) => TKey): T[] {
  return this.reduce((current, x) => {
    const key = selector(x);
    if (!current.keys.includes(key)) {
      current.keys.push(key);
      current.values.push(x);
    }
    return current;
  }, { values: [], keys: [] }).values;
}

Map.prototype.toArray = function <K, V>(this: Map<K, V>): { key: K; value: V }[] {
  return Array.from(this, ([key, value]) => ({ key, value }));
}

export { };

export function when<T>(condition: boolean, ...element: T[]): T[] {
  return condition ? element : [];
}
